// removed by extract-text-webpack-plugin
module.exports = {"container":"index__container--3fKuL","headline":"index__headline--3F3C-","errorIcon":"index__errorIcon--34gwI","refreshIcon":"index__refreshIcon--1AvsT","btn":"index__btn--zB7JK"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/FailureScreen/styles/index.scss
// module id = nchU
// module chunks = 23